import React from "react";
import {
  TrashIcon,
  InformationCircleIcon,
  PencilSquareIcon,
} from "@heroicons/react/24/solid";

const ShopBrandsRowDetails = ({ details, onDelete, onEdit }) => {
  const values = [
    details.number,
    details.nameEN,
    details.nameAR,
    details.link,
    details.img,
  ];

  return (
    <tr className="text-sm text-center text-gray-800 bg-white">
      {values.map((value, index) => (
        <td key={index} className="px-2 py-2">
          {index === 6 ? (
            <span title={value} className="text-black cursor-pointer">
              <InformationCircleIcon className="inline-block w-5 h-5 cursor-pointer text-custom-yellow" />
              Hover
            </span>
          ) : index === 3 ? (
            <a
              href={value}
              target="_blank"
              rel="noopener noreferrer"
              className="object-cover w-10 px-2 mx-auto rounded-sm bg-custom-yellow"
            >
              Link
            </a>
          ) : index === 4 ? (
            <img
              src={value}
              alt="Image"
              className="object-cover w-10 mx-auto "
            />
          ) : index === 5 ? (
            <span title={value} className="text-black cursor-pointer">
              <a
                href={value}
                className="px-2 py-1 text-black duration-300 rounded-lg bg-custom-yellow hover:bg-yellow-100"
              >
                {values[1]}
              </a>
            </span>
          ) : (
            value
          )}
        </td>
      ))}
      <td className="px-2 py-2">
        <div className="flex justify-center space-x-2">
          <button onClick={onDelete}>
            <TrashIcon className="w-5 h-5 text-red-600" />
          </button>
          <button onClick={onEdit}>
            <PencilSquareIcon className="w-5 h-5 text-black" />
          </button>
        </div>
      </td>
    </tr>
  );
};

export default ShopBrandsRowDetails;
